// imports
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HeaderComponent } from "../../components/header/header.component";
import { ModalBajaLeadComponent } from "../../components/modal-baja-lead/modal-baja-lead.component";

// tenemos que importar
// y exportar
@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HeaderComponent,
        ModalBajaLeadComponent
    ], imports: [CommonModule, FormsModule, ReactiveFormsModule, HeaderComponent,
        ModalBajaLeadComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule {}
